export default __webpack_public_path__ + "assets/home-one-one-small.be0aefcd44b4d497840d00a0e5a379b3.png";